/**
 *
 * @name app.infrastructure:EventBusRun
 * @date
 * @copyright 2015 Empower Retirement
 * @description
 *
 *      Makes the event bus available on the globalThis window object.
 */
var EventBusRun = function (eventBus) {
    // add the event bus to the globalThis window object
    eventBus.addToGlobal();
};

// Create a reference for injected objects to protect against minification
EventBusRun.$inject = ["eventBus"];
export default EventBusRun;
